import amplitude from 'amplitude-js';

export const ampInstance = amplitude.getInstance();
ampInstance.init(process.env.REACT_APP_AMPLITUDE_API_KEY);

export const LogEvent=(event, eventProperties)=>{
    // send an event
    amplitude.getInstance().logEvent(event, eventProperties);
};
